// extracted by mini-css-extract-plugin
var _1 = "costco--subscription-module__form--btn--L2FwcC";
var _2 = "costco--subscription-module__form--login--L2FwcC";
var _3 = "costco--subscription-module__inputs--L2FwcC";
var _4 = "costco--subscription-module__login--body--L2FwcC";
var _5 = "costco--subscription-module__login--form--L2FwcC";
var _6 = "costco--subscription-module__login--input--L2FwcC";
var _7 = "costco--subscription-module__login--title--L2FwcC";
var _8 = "costco--subscription-module__logo--web--L2FwcC";
var _9 = "costco--subscription-module__sso--L2FwcC";
var _a = "costco--subscription-module__success--div--L2FwcC";
var _b = "costco--subscription-module__success--logo--L2FwcC";
var _c = "costco--subscription-module__title--form--L2FwcC";
var _d = "costco--subscription-module__verification--title--L2FwcC";
var _e = "costco--subscription-module__verify--new--L2FwcC";
export { _1 as "formBtn", _2 as "formLogin", _3 as "inputs", _4 as "loginBody", _5 as "loginForm", _6 as "loginInput", _7 as "loginTitle", _8 as "logoWeb", _9 as "sso", _a as "successDiv", _b as "successLogo", _c as "titleForm", _d as "verificationTitle", _e as "verifyNew" }
